import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ItemDateCard from "~business/Cards/ItemDateCard";
import DetalleCard from "~business/Cards/DetalleCard";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  getEmisiones,
  getEmisionesDeComisiones,
  setFechaDesde,
  setFechaHasta,
} from "./actions";

const useReduxSelector = () =>
  useSelector((state) => ({
    ...state.getEmisionesReducer,
  }));

const EmisionesCard = () => {
  const dispatch = useDispatch();
  const {
    fechaDesdeSelected,
    fechaHastaSelected,
    buttonEnabled,
    buttonText,
    buttonComisionesText,
  } = useReduxSelector();

  const handleChangeFechaDesde = (fechaDesde) => {
    dispatch(setFechaDesde(fechaDesde));
  };
  const handleChangeFechaHasta = (fechaHasta) => {
    dispatch(setFechaHasta(fechaHasta));
  };
  const handleGetEmisiones = () => {
    let data = {
      fechaDesde: fechaDesdeSelected.value,
      fechaHasta: fechaHastaSelected.value,
    };
    dispatch(getEmisiones(data));
  };
  const handleGetEmisionesDeComisiones = () => {
    let data = {
      fechaDesde: fechaDesdeSelected.value,
      fechaHasta: fechaHastaSelected.value,
    };
    dispatch(getEmisionesDeComisiones(data));
  };

  return (
    <>
      <DetalleCard title={"Emisiones"}>
        <ItemDateCard
          label="Desde"
          value={fechaDesdeSelected.value}
          onChange={handleChangeFechaDesde}
        />
        <ItemDateCard
          label="Hasta"
          value={fechaHastaSelected.value}
          onChange={handleChangeFechaHasta}
        />
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm="auto">
              <Button
                variant="contained"
                color="primary"
                onClick={handleGetEmisiones}
                disabled={!buttonEnabled}
              >
                {buttonText}
              </Button>
            </Grid>
            <Grid item xs={12} sm="auto">
              <Button
                variant="contained"
                color="primary"
                onClick={handleGetEmisionesDeComisiones}
                disabled={!buttonEnabled}
              >
                {buttonComisionesText}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </DetalleCard>
    </>
  );
};

export default EmisionesCard;
